import { ROLE_LSP } from '@/utils/const';

export const MENU = {

  leftMenu: [{
    name: 'Home',
    url: '/',
    icon: 'icon-home',
    nameRoute: 'welcome_page',
    permission: 'menu.home',
  },
  {
    name: 'Overview',
    url: '/overview-list',
    icon: 'icon-overview',
    permission: 'menu.overview',
    roleDisable: [ROLE_LSP],
  },
  {
    name: 'Projects',
    url: '/project-groups/tile/filters/projects',
    dropdown: [{
      name: 'Table view',
      url: '/project-groups/table/filters/projects',
      icon: 'icon-table-view',
    },
    {
      name: 'Tile view',
      url: '/project-groups/tile/filters/projects',
      icon: 'icon-tile-view',
    },
    ],
    icon: 'icon-projects',
    permission: 'menu.projects',
    roleDisable: [ROLE_LSP],
  },
  {
    name: 'Tasks',
    url: '/projects/tile/filters/tasks',
    dropdown: [{
      name: 'Table view',
      url: '/projects/table/filters/tasks',
      icon: 'icon-table-view',
    },
    {
      name: 'Tile view',
      url: '/projects/tile/filters/tasks',
      icon: 'icon-tile-view',
    },
    ],
    icon: 'icon-tasks',
    permission: 'menu.tasks',
    roleDisable: [ROLE_LSP],
  },
  {
    name: 'Jobs',
    url: '/jobs/tile/filters/jobs',
    dropdown: [{
      name: 'Timeline view',
      url: '/jobs/timeline/filters/jobs',
      icon: 'icon-timeline-view',
    },
    {
      name: 'Table view',
      url: '/jobs/tile/filters/jobs',
      icon: 'icon-table-view',
    },
    ],
    icon: 'icon-jobs',
    permission: 'menu.jobs',
    roleDisable: [ROLE_LSP],
  },
  {
    name: 'Reports',
    url: '/reports/table/filters/reports/',
    icon: 'icon-reports',
    permission: 'menu.reports',
  },
  {
    name: 'Dashboards',
    url: '/dashboards',
    icon: 'icon-dashboards',
    dropdown: [{
      name: 'Overall quality dashboards',
      url: '/dashboards/overall',
      icon: 'icon-award',
    },
    {
      name: 'Company dashboards',
      url: '/dashboards/company',
      icon: 'icon-factory',
      dropdown: [{
        name: 'KPI',
        url: '/dashboards/company/',
      },
      {
        name: 'Results',
        url: '/dashboards/company/results',
      },
      {
        name: 'Trends',
        url: '/dashboards/company/trends',
      },
      ],
    },
    {
      name: 'Vendors dashdoards',
      url: '/dashboards/vendors',
      icon: 'icon-vendors',
      dropdown: [{
        name: 'KPI',
        url: '/dashboards/vendors/',
      },
      {
        name: 'Results',
        url: '/dashboards/vendors/results',
      },
      {
        name: 'Trends',
        url: '/dashboards/vendors/trends',
      },
      ],
    },
    {
      name: 'Countries dashboards',
      url: '/dashboards/rating_map',
      icon: 'icon-world',
      dropdown: [{
        name: 'KPI',
        url: '/dashboards/rating_map',
      },
      {
        name: 'Results',
        url: '/dashboards/rating_map/results',
      },
      {
        name: 'Trends',
        url: '/dashboards/rating_map/trends',
      },
      ],
    },
    {
      name: 'Ranking dashboards',
      url: '/dashboards/ranking',
      icon: 'ranking',
    },
    {
      name: 'Error intelligence',
      url: '/dashboards/errors_intelligence',
      icon: 'icon-error-intelligence',
    },

    ],
    permission: 'menu.dashboards',
    roleDisable: [ROLE_LSP],
  },
  {
    name: 'Documentation',
    url: '/documentation/tile',
    icon: 'icon-documentation',
    permission: 'menu.documentation',
    roleDisable: [ROLE_LSP],
  },
  ],

  settingsMenu: [{
    name: 'General configuration',
    url: '#',
    permissions: 94,
    disabled: true,
    hiddenChild: false,
    slug: 'ge',
    dropdown: [{
      name: 'Branding',
      url: '#',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Logo',
        url: '/settings/logo',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Customizations',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'Formatting',
      url: '/settings/formatting',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Number and date formatting',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Localization',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Views',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'Templates',
      url: '#',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Documents',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Notifications',
        url: '/settings/notifications',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Charts',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Reports',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Forms',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'User management',
      url: '/settings/user_administration',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'User groups and rights',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Users and rights',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Administrator data',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'Values and rules',
      url: '#',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Overviews',
        url: '/overview-list',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Projects',
        url: '/project-groups/tile/filters/projects',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Tasks',
        url: '/projects/tile/filters/tasks',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Jobs',
        url: '/jobs/tile/filters/jobs',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Reports',
        url: '/reports/table/filters/reports',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Dashboards',
        url: '/dashboards',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Documentation',
        url: '/documentation/tile',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    ],
  },
  {
    name: 'Workflows configuration',
    slug: 'wc',
    url: '#',
    permissions: 94,
    hiddenChild: false,
    disabled: true,
    dropdown: [{
      name: 'Workflows',
      url: '#',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Process templates',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Steps to be used',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'Steps',
      url: '/settings/worlflow_steps',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Manual steps',
        url: '#',
        permissions: 94,
        disabled: false,
        list: [{
          name: 'Project steps',
          url: '#',
          permissions: 94,
          disabled: false,
        },
        {
          name: 'Task steps',
          url: '#',
          permissions: 94,
          disabled: false,
        },
        {
          name: 'Job steps',
          url: '#',
          permissions: 94,
          disabled: false,
        },
        ],
      },
      {
        name: 'Automatic steps',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Connector steps',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'Roles',
      url: '#',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Providers selection',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Project manager selection',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'Files to be delivered',
      url: '/settings/workflow_documents',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Reference files',
        url: '#',
        permissions: 94,
        disabled: false,
        list: [{
          name: 'CAT Analysis',
          url: '#',
          permissions: 94,
          disabled: false,
        },
        {
          name: 'QA Report',
          url: '#',
          permissions: 94,
          disabled: false,
        },
        {
          name: 'Reference file',
          url: '#',
          permissions: 94,
          disabled: false,
        },
        {
          name: 'Terminology',
          url: '#',
          permissions: 94,
          disabled: false,
        },
        {
          name: 'Translation memory',
          url: '#',
          permissions: 94,
          disabled: false,
        },
        {
          name: 'Other',
          url: '#',
          permissions: 94,
          disabled: false,
        },
        ],
      },
      {
        name: 'Work files',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'Automations',
      url: '#',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Bilingual document',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Translated document',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Source document',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Target document',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'CAT Package',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'CAT Package (Return)',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Formatter document',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    ],

  },
  {
    name: 'Plug-in and connector',
    url: '#',
    permissions: 94,
    hiddenChild: false,
    disabled: true,
    slug: 'pl',
    dropdown: [{
      name: 'Plug-ins',
      url: '#',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Cat tools',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'QA models',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'QA methods',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'QA reports templates',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'Connectors',
      url: '#',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Cat tools',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'CMS',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Other',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'SLA',
      url: '#',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Providers selection',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Project manager selection',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Support level',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Updates',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'API documentation',
      url: '#',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Mappings',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Manuals',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'Licences managment',
      url: '#',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Licences',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Servers',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Web Services',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Log files',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    ],

  },
  {
    name: 'MyProof',
    url: '#',
    permissions: 94,
    hiddenChild: false,
    disabled: true,
    slug: 'my',
    dropdown: [{
      name: 'Evaluation Methods',
      url: '/settings/evaluation_methods',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Quick check',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Deep scan',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'Risk levels and quality levels',
      url: '#',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Support level',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Updates',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'Error settings',
      url: '/settings/error_configuration',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Error categories',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Error severity',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'Superordinate rules',
      url: '/settings/metarules',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Repetition (REP)',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Reference material (REF)',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Source language text (SLT)',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'K-O error',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Other',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'QA models and metrics',
      url: '/settings/metrics',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Industry sector(s) and branches',
        url: '/settings/industry_classification',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Document type(s)',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    {
      name: 'Languages',
      url: '/settings/languages_cinfiguration',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Source language(s)',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Target language(s)',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Language combinations',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],

    },
    {
      name: 'Risk levels and quality levels',
      url: '#',
      permissions: 94,
      disabled: false,
      links: [{
        name: 'Countries',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Official languages',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      {
        name: 'Currencies',
        url: '#',
        permissions: 94,
        disabled: false,
      },
      ],
    },
    ],
  },
  ],
};
